<ng-container *ngIf="selectedContent">
    <div class="editor-wrapper">
        <div class="element-container">
            <div class="content-elements">
                <div class="element-selector">
                    {{selectedContent?.name}}:<br/>{{selectedContent?.description}}
                </div>
            </div>
    
            <div class="select-row">
                <!-- <div class="element-selector">
                    <div class="element-label">
                        <div class="title">Element:</div>
                    </div>
                    <div class="element-label selector">
                        <nb-select [(selected)]="selectedContent" [placeholder]="selectedContent"  (selectedChange)="changeContent($event)" size="small">
                            <nb-option *ngFor="let content of contentElements" [value]="content">{{ content.name }}</nb-option>
                        </nb-select>
                    </div>
                </div> -->
                <div class="element-selector">
                    <nb-actions size="tiny">
                        <nb-action class="title">Font:</nb-action>
                    </nb-actions>
                </div>
                <div class="element-values">
                    <nb-actions size="tiny">
                        <nb-action [title]="selectedContent.isHeader?'Title Style':'Size'" class="popover-icon"
                            [nbPopover]="fontSizePop" 
                            [nbPopoverContext]="{title:'Font Size',fontSizes:fontSizes,headers:headers,content:selectedContent,target:'self',declaration:'fontSize',status:status}" 
                            nbPopoverPlacement="top">
                            <ng-container *ngIf="selectedContent.isHeader;else normalText">
                                <svg viewBox="0 0 24 24" id="ic_title_24px" width="100%" height="100%" fill="var(--actions-icon-color)">
                                    <path d="M5 4v3h5.5v12h3V7H19V4z" />
                                </svg>
                            </ng-container>
                            <ng-template #normalText>
                                <svg viewBox="0 0 24 24" id="ic_format_size_24px" width="100%" height="100%" fill="var(--actions-icon-color)">
                                    <path d="M9 4v3h5v12h3V7h5V4H9zm-6 8h3v7h3v-7h3V9H3v3z" />
                                </svg>
                            </ng-template>
                        </nb-action>
                        <nb-action title="Weight" 
                            class="popover-icon"
                            [nbPopover]="fontWeightPop"
                            [nbPopoverContext]="{title:'Font Weight',weights:weights,content:selectedContent,target:'self',declaration:'fontWeight',status:status}">
                            <svg viewBox="0 0 24 24" id="ic_format_bold_24px" width="100%" height="100%" fill="var(--actions-icon-color)">
                                <path d="M15.6 10.79c.97-.67 1.65-1.77 1.65-2.79 0-2.26-1.75-4-4-4H7v14h7.04c2.09 0 3.71-1.7 3.71-3.79 0-1.52-.86-2.82-2.15-3.42zM10 6.5h3c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-3v-3zm3.5 9H10v-3h3.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5z" />
                            </svg>
                        </nb-action>
                    <!-- <nb-action title="Title Style" (click)="setContainerLayout('container-content-top')">
                        
                    </nb-action> -->
                    <nb-action title="Font Family"
                        class="popover-icon"
                        [nbPopover]="fontFamPop" 
                        [nbPopoverContext]="{title:'Font Family',fontFams:fontFams,content:selectedContent,target:'self',declaration:'fontFamily',status:status}">
                        <svg viewBox="0 0 24 24" id="ic_format_shapes_24px" width="100%" height="100%" fill="var(--actions-icon-color)">
                            <path d="M23 7V1h-6v2H7V1H1v6h2v10H1v6h6v-2h10v2h6v-6h-2V7h2zM3 3h2v2H3V3zm2 18H3v-2h2v2zm12-2H7v-2H5V7h2V5h10v2h2v10h-2v2zm4 2h-2v-2h2v2zM19 5V3h2v2h-2zm-5.27 9h-3.49l-.73 2H7.89l3.4-9h1.4l3.41 9h-1.63l-.74-2zm-3.04-1.26h2.61L12 8.91l-1.31 3.83z"/>
                        </svg>
                    </nb-action>
                    <nb-action title="Underline" 
                        class="popover-icon"
                        [nbPopover]="underlinePop" 
                        [nbPopoverContext]="{content:selectedContent,status:status}" nbPopoverPlacement="top">
                        <svg viewBox="0 0 24 24" id="ic_format_underlined_24px" width="100%" height="100%" fill="var(--actions-icon-color)">
                            <path d="M12 17c3.31 0 6-2.69 6-6V3h-2.5v8c0 1.93-1.57 3.5-3.5 3.5S8.5 12.93 8.5 11V3H6v8c0 3.31 2.69 6 6 6zm-7 2v2h14v-2H5z" />
                        </svg>
                    </nb-action>
                    <nb-action title="Italic" (click)="setContainerLayout('container-content-top')">
                        <svg viewBox="0 0 24 24" id="ic_format_italic_24px" width="100%" height="100%" fill="var(--actions-icon-color)">
                            <path d="M10 4v3h2.21l-3.42 8H6v3h8v-3h-2.21l3.42-8H18V4z" />
                        </svg>
                    </nb-action>
                    <nb-action title="Text Color"
                        class="popover-icon"
                        [nbPopover]="component" 
                        [nbPopoverContext]="{color:textColor,colors:fillColors,content:selectedContent,status:status}" nbPopoverPlacement="top">
                        <svg viewBox="0 0 24 24" id="ic_format_color_text_24px" width="100%" height="100%" fill="var(--actions-icon-color)">
                            <path fill-opacity=".36" d="M0 20h24v4H0z" />
                            <path d="M11 3L5.5 17h2.25l1.12-3h6.25l1.12 3h2.25L13 3h-2zm-1.38 9L12 5.67 14.38 12H9.62z" />
                        </svg>
                    </nb-action>
                    </nb-actions>
                </div>
                <div class="element-selector">
                    <nb-actions size="tiny">
                        <nb-action>V Align:</nb-action>
                    </nb-actions>
                </div>
                <div class="element-values">
                    <nb-actions size="tiny">
                        <nb-action title="V Align Top" (click)="setContainerLayout('container-content-top')" class="popover-icon">
                            <svg viewBox="0 0 24 24" id="ic_vertical_align_top_24px" width="100%" height="100%" fill="var(--actions-icon-color)">
                                <path d="M8 11h3v10h2V11h3l-4-4-4 4zM4 3v2h16V3H4z" />
                            </svg>
                        </nb-action>
                        <nb-action title="V Align Middle" (click)="setContainerLayout('container-content-middle')" class="popover-icon">
                            <svg viewBox="0 0 24 24" id="ic_vertical_align_center_24px" width="100%" height="100%" fill="var(--actions-icon-color)">
                                <path d="M8 19h3v4h2v-4h3l-4-4-4 4zm8-14h-3V1h-2v4H8l4 4 4-4zM4 11v2h16v-2H4z" />
                            </svg>
                        </nb-action>
                        <nb-action title="V Align Bottom" (click)="setContainerLayout('container-content-bottom')" class="popover-icon">
                            <svg viewBox="0 0 24 24" id="ic_vertical_align_bottom_24px" width="100%" height="100%" fill="var(--actions-icon-color)">
                                <path d="M16 13h-3V3h-2v10H8l4 4 4-4zM4 19v2h16v-2H4z" />
                            </svg>
                        </nb-action>
                    </nb-actions>
                </div>
                <div class="element-selector">
                    <nb-actions size="tiny">
                        <nb-action>H Align:</nb-action>
                    </nb-actions>
                </div>
                <div class="element-values">
                    <nb-actions size="tiny">    
                        <nb-action title="H Align Left" (click)="setHorizontalAlign('justify-left')" class="popover-icon">
                            <svg viewBox="0 0 24 24" id="ic_format_align_left_24px" width="100%" height="100%" fill="var(--actions-icon-color)">
                                <path d="M15 15H3v2h12v-2zm0-8H3v2h12V7zM3 13h18v-2H3v2zm0 8h18v-2H3v2zM3 3v2h18V3H3z" />
                            </svg>
                        </nb-action>
                        <nb-action title="H Align Center" (click)="setHorizontalAlign('justify-center')" class="popover-icon">
                            <svg viewBox="0 0 24 24" id="ic_format_align_center_24px" width="100%" height="100%" fill="var(--actions-icon-color)">
                                <path d="M7 15v2h10v-2H7zm-4 6h18v-2H3v2zm0-8h18v-2H3v2zm4-6v2h10V7H7zM3 3v2h18V3H3z" />
                            </svg>
                        </nb-action>
                        <nb-action title="H Align Right" (click)="setHorizontalAlign('justify-right')" class="popover-icon">
                            <svg viewBox="0 0 24 24" id="ic_format_align_right_24px" width="100%" height="100%" fill="var(--actions-icon-color)">
                                <path d="M3 21h18v-2H3v2zm6-4h12v-2H9v2zm-6-4h18v-2H3v2zm6-4h12V7H9v2zM3 3v2h18V3H3z" />
                            </svg>
                        </nb-action>
                        <nb-action title="Fill Color"
                            class="popover-icon"
                            [nbPopover]="component" 
                            [nbPopoverContext]="{color:textColor,colors:fillColors,content:selectedContent,target:'self',property:'background'}" nbPopoverPlacement="top">
                            <svg viewBox="0 0 24 24" id="ic_format_color_fill_24px" width="100%" height="100%" fill="var(--actions-icon-color)">
                                <path d="M16.56 8.94L7.62 0 6.21 1.41l2.38 2.38-5.15 5.15a1.49 1.49 0 0 0 0 2.12l5.5 5.5c.29.29.68.44 1.06.44s.77-.15 1.06-.44l5.5-5.5c.59-.58.59-1.53 0-2.12zM5.21 10L10 5.21 14.79 10H5.21zM19 11.5s-2 2.17-2 3.5c0 1.1.9 2 2 2s2-.9 2-2c0-1.33-2-3.5-2-3.5z"/>
                                <path fill-opacity=".36" d="M0 20h24v4H0z" />
                            </svg>
                        </nb-action>
                        
                        <nb-action>
                            <button nbButton size="tiny" (click)="openRandomDialog()">Random Dialog</button>
                        </nb-action>
                        
                        <!-- <nb-action>
                            <button nbButton size="tiny" [nbPopover]="component" [nbPopoverContext]="{color:textColor,colors:fillColors,content:selectedContent,target:'parent',property:'background'}" nbPopoverPlacement="left">Background</button>
                        </nb-action> -->
                        <!-- <nb-action>Vertical Align:</nb-action>
                        <nb-action [ngStyle]="{'min-width':'8 rem'}">
                            <nb-select [(selected)]="selectedContainerLayout" [placeholder]="selectedContainerLayout"  (selectedChange)="onChangeContainerLayout($event)" size="tiny" class="action-select">
                                <nb-option *ngFor="let containerLayout of containerLayouts" [value]="containerLayout">{{ containerLayout.name }}</nb-option>
                            </nb-select>
                        </nb-action>
                        <nb-action>Horisontal Align:</nb-action>
                        <nb-action [ngStyle]="{'min-width':'8 rem'}">
                            <nb-select [(selected)]="selectedAlignment" [placeholder]="selectedAlignment"  (selectedChange)="onChangeAlign($event)" size="tiny" class="action-select">
                                <nb-option *ngFor="let alignment of alignments" [value]="alignment">{{ alignment.name }}</nb-option>
                            </nb-select>
                        </nb-action>-->
                        <!-- <nb-action> 
                            <button nbButton size="tiny">Border</button>
                        </nb-action> -->
                    </nb-actions>
                </div>
                <div class="element-selector">
                    <nb-actions size="tiny">
                        <nb-action>Container Styles:</nb-action>    
                    </nb-actions>
                </div>
            </div>
            <div class="select-row">
                <div class="element-selector">
                    <nb-actions size="tiny">
                        <nb-action class="title">Margin:</nb-action>
                    </nb-actions>
                </div>
                <div class="element-values">
                    <nb-actions size="tiny">
                        <nb-action title="All"
                        class="popover-icon"
                        [nbPopover]="paddingPop" 
                        [nbPopoverContext]="{title:'Margin',color:textColor,colors:fillColors,content:selectedContent,target:'parent',property:'margin',status:status}" nbPopoverPlacement="top">
                            <svg viewBox="0 0 24 24" id="ic_border_outer_24px" width="100%" height="100%" fill="var(--actions-icon-color)">
                                <path d="M13 7h-2v2h2V7zm0 4h-2v2h2v-2zm4 0h-2v2h2v-2zM3 3v18h18V3H3zm16 16H5V5h14v14zm-6-4h-2v2h2v-2zm-4-4H7v2h2v-2z" />
                            </svg>
                        </nb-action>
                        <nb-action title="Top" 
                            class="popover-icon"
                            [nbPopover]="paddingPop"
                            nbPopoverPlacement="top"
                            [nbPopoverContext]="{title:'Margin',color:textColor,colors:fillColors,content:selectedContent,target:'parent',property:'marginTop'}">
                            <svg viewBox="0 0 24 24" id="ic_border_top_24px" width="100%" height="100%" fill="var(--actions-icon-color)">
                                <path d="M7 21h2v-2H7v2zm0-8h2v-2H7v2zm4 0h2v-2h-2v2zm0 8h2v-2h-2v2zm-8-4h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2v-2H3v2zm0-4h2V7H3v2zm8 8h2v-2h-2v2zm8-8h2V7h-2v2zm0 4h2v-2h-2v2zM3 3v2h18V3H3zm16 14h2v-2h-2v2zm-4 4h2v-2h-2v2zM11 9h2V7h-2v2zm8 12h2v-2h-2v2zm-4-8h2v-2h-2v2z"/>
                            </svg>
                        </nb-action>
                        <nb-action title="Right" 
                        class="popover-icon"
                            [nbPopover]="paddingPop"
                            nbPopoverPlacement="top"
                            [nbPopoverContext]="{title:'Margin',color:textColor,colors:fillColors,content:selectedContent,target:'parent',property:'marginRight'}">
                            <svg viewBox="0 0 24 24" id="ic_border_right_24px" width="100%" height="100%" fill="var(--actions-icon-color)">
                                <path d="M7 21h2v-2H7v2zM3 5h2V3H3v2zm4 0h2V3H7v2zm0 8h2v-2H7v2zm-4 8h2v-2H3v2zm8 0h2v-2h-2v2zm-8-8h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm8 8h2v-2h-2v2zm4-4h2v-2h-2v2zm4-10v18h2V3h-2zm-4 18h2v-2h-2v2zm0-16h2V3h-2v2zm-4 8h2v-2h-2v2zm0-8h2V3h-2v2zm0 4h2V7h-2v2z"/>
                            </svg>
                        </nb-action>
                        <nb-action title="Bottom" 
                            class="popover-icon"
                            [nbPopover]="paddingPop"
                            nbPopoverPlacement="top"
                            [nbPopoverContext]="{title:'Margin',color:textColor,colors:fillColors,content:selectedContent,target:'parent',property:'marginBottom'}">
                            <svg viewBox="0 0 24 24" id="ic_border_bottom_24px" width="100%" height="100%" fill="var(--actions-icon-color)">
                                <path d="M9 11H7v2h2v-2zm4 4h-2v2h2v-2zM9 3H7v2h2V3zm4 8h-2v2h2v-2zM5 3H3v2h2V3zm8 4h-2v2h2V7zm4 4h-2v2h2v-2zm-4-8h-2v2h2V3zm4 0h-2v2h2V3zm2 10h2v-2h-2v2zm0 4h2v-2h-2v2zM5 7H3v2h2V7zm14-4v2h2V3h-2zm0 6h2V7h-2v2zM5 11H3v2h2v-2zM3 21h18v-2H3v2zm2-6H3v2h2v-2z"/>
                            </svg>
                        </nb-action>
                        <nb-action title="Left" 
                            class="popover-icon"
                            [nbPopover]="paddingPop"
                            nbPopoverPlacement="top"
                            [nbPopoverContext]="{title:'Margin',color:textColor,colors:fillColors,content:selectedContent,target:'parent',property:'marginLeft'}">
                            <svg viewBox="0 0 24 24" id="ic_border_left_24px" width="100%" height="100%" fill="var(--actions-icon-color)">
                                <path d="M11 21h2v-2h-2v2zm0-4h2v-2h-2v2zm0-12h2V3h-2v2zm0 4h2V7h-2v2zm0 4h2v-2h-2v2zm-4 8h2v-2H7v2zM7 5h2V3H7v2zm0 8h2v-2H7v2zm-4 8h2V3H3v18zM19 9h2V7h-2v2zm-4 12h2v-2h-2v2zm4-4h2v-2h-2v2zm0-14v2h2V3h-2zm0 10h2v-2h-2v2zm0 8h2v-2h-2v2zm-4-8h2v-2h-2v2zm0-8h2V3h-2v2z"/>
                            </svg>
                        </nb-action>
                    </nb-actions>
                </div>    
            </div>
            <div class="select-row">
                <div class="element-selector">
                    <nb-actions size="tiny">
                        <nb-action class="title">Border:</nb-action>
                    </nb-actions>
                </div>
                <div class="element-values">
                    <nb-actions size="tiny">
                        <nb-action title="All"
                        class="popover-icon"
                        [nbPopover]="borderPop" 
                            [nbPopoverContext]="{title:'Border',color:textColor,colors:fillColors,content:selectedContent,target:'parent',property:'background',status:status}" nbPopoverPlacement="top">
                            <svg viewBox="0 0 24 24" id="ic_border_outer_24px" width="100%" height="100%" fill="var(--actions-icon-color)">
                                <path d="M13 7h-2v2h2V7zm0 4h-2v2h2v-2zm4 0h-2v2h2v-2zM3 3v18h18V3H3zm16 16H5V5h14v14zm-6-4h-2v2h2v-2zm-4-4H7v2h2v-2z" />
                            </svg>
                        </nb-action>
                        <nb-action title="Top" 
                            class="popover-icon"
                            [nbPopover]="paddingPop"
                            nbPopoverPlacement="top"
                            [nbPopoverContext]="{title:'Border',color:textColor,colors:fillColors,content:selectedContent,target:'parent',property:'borderTop'}">
                            <svg viewBox="0 0 24 24" id="ic_border_top_24px" width="100%" height="100%" fill="var(--actions-icon-color)">
                                <path d="M7 21h2v-2H7v2zm0-8h2v-2H7v2zm4 0h2v-2h-2v2zm0 8h2v-2h-2v2zm-8-4h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2v-2H3v2zm0-4h2V7H3v2zm8 8h2v-2h-2v2zm8-8h2V7h-2v2zm0 4h2v-2h-2v2zM3 3v2h18V3H3zm16 14h2v-2h-2v2zm-4 4h2v-2h-2v2zM11 9h2V7h-2v2zm8 12h2v-2h-2v2zm-4-8h2v-2h-2v2z"/>
                            </svg>
                        </nb-action>
                        <nb-action title="Right" 
                        class="popover-icon"
                            [nbPopover]="paddingPop"
                            nbPopoverPlacement="top"
                            [nbPopoverContext]="{title:'Border',color:textColor,colors:fillColors,content:selectedContent,target:'parent',property:'borderRight'}">
                            <svg viewBox="0 0 24 24" id="ic_border_right_24px" width="100%" height="100%" fill="var(--actions-icon-color)">
                                <path d="M7 21h2v-2H7v2zM3 5h2V3H3v2zm4 0h2V3H7v2zm0 8h2v-2H7v2zm-4 8h2v-2H3v2zm8 0h2v-2h-2v2zm-8-8h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm8 8h2v-2h-2v2zm4-4h2v-2h-2v2zm4-10v18h2V3h-2zm-4 18h2v-2h-2v2zm0-16h2V3h-2v2zm-4 8h2v-2h-2v2zm0-8h2V3h-2v2zm0 4h2V7h-2v2z"/>
                            </svg>
                        </nb-action>
                        <nb-action title="Bottom" 
                            class="popover-icon"
                            [nbPopover]="paddingPop"
                            nbPopoverPlacement="top"
                            [nbPopoverContext]="{title:'Border',color:textColor,colors:fillColors,content:selectedContent,target:'parent',property:'borderBottom'}">
                            <svg viewBox="0 0 24 24" id="ic_border_bottom_24px" width="100%" height="100%" fill="var(--actions-icon-color)">
                                <path d="M9 11H7v2h2v-2zm4 4h-2v2h2v-2zM9 3H7v2h2V3zm4 8h-2v2h2v-2zM5 3H3v2h2V3zm8 4h-2v2h2V7zm4 4h-2v2h2v-2zm-4-8h-2v2h2V3zm4 0h-2v2h2V3zm2 10h2v-2h-2v2zm0 4h2v-2h-2v2zM5 7H3v2h2V7zm14-4v2h2V3h-2zm0 6h2V7h-2v2zM5 11H3v2h2v-2zM3 21h18v-2H3v2zm2-6H3v2h2v-2z"/>
                            </svg>
                        </nb-action>
                        <nb-action title="Left" 
                            class="popover-icon"
                            [nbPopover]="paddingPop"
                            nbPopoverPlacement="top"
                            [nbPopoverContext]="{title:'Border',color:textColor,colors:fillColors,content:selectedContent,target:'parent',property:'borderLeft'}">
                            <svg viewBox="0 0 24 24" id="ic_border_left_24px" width="100%" height="100%" fill="var(--actions-icon-color)">
                                <path d="M11 21h2v-2h-2v2zm0-4h2v-2h-2v2zm0-12h2V3h-2v2zm0 4h2V7h-2v2zm0 4h2v-2h-2v2zm-4 8h2v-2H7v2zM7 5h2V3H7v2zm0 8h2v-2H7v2zm-4 8h2V3H3v18zM19 9h2V7h-2v2zm-4 12h2v-2h-2v2zm4-4h2v-2h-2v2zm0-14v2h2V3h-2zm0 10h2v-2h-2v2zm0 8h2v-2h-2v2zm-4-8h2v-2h-2v2zm0-8h2V3h-2v2z"/>
                            </svg>
                        </nb-action>
                        <nb-action title="Border Color"
                            class="popover-icon"
                            [nbPopover]="component" 
                            [nbPopoverContext]="{color:textColor,colors:fillColors,content:selectedContent,target:'self',property:'border',status:status}" nbPopoverPlacement="top">
                            <svg viewBox="0 0 24 24" id="ic_border_color_24px" width="100%" height="100%" fill="var(--actions-icon-color)">
                                <path d="M17.75 7L14 3.25l-10 10V17h3.75l10-10zm2.96-2.96a.996.996 0 0 0 0-1.41L18.37.29a.996.996 0 0 0-1.41 0L15 2.25 18.75 6l1.96-1.96z" />
                                <path fill-opacity=".36" d="M0 20h24v4H0z" />
                            </svg>
                        </nb-action>
                        <nb-action title="Border Radius Presets"
                            class="popover-icon"
                            [nbPopover]="component" 
                            [nbPopoverContext]="{color:textColor,colors:fillColors,content:selectedContent}" nbPopoverPlacement="top">
                            <svg fill="none" width="100%" height="100%" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <path d="m3 5.75c0-1.51878 1.23122-2.75 2.75-2.75h12.5c1.5188 0 2.75 1.23122 2.75 2.75v12.5c0 1.5188-1.2312 2.75-2.75 2.75h-12.5c-1.51878 0-2.75-1.2312-2.75-2.75zm2.75-1.25c-.69036 0-1.25.55964-1.25 1.25v12.5c0 .6904.55964 1.25 1.25 1.25h12.5c.6904 0 1.25-.5596 1.25-1.25v-12.5c0-.69036-.5596-1.25-1.25-1.25z" fill="#212121"/>
                            </svg>
                        </nb-action>
                        <nb-action title="Border Radius"
                            class="popover-icon"
                            [nbPopover]="component" 
                            [nbPopoverContext]="{color:textColor,colors:fillColors,content:selectedContent}" nbPopoverPlacement="top">
                            <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-border-radius" width="100%" height="100%" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                                <path d="M4 12v-4a4 4 0 0 1 4 -4h4" />
                                <line x1="16" y1="4" x2="16" y2="4.01" />
                                <line x1="20" y1="4" x2="20" y2="4.01" />
                                <line x1="20" y1="8" x2="20" y2="8.01" />
                                <line x1="20" y1="12" x2="20" y2="12.01" />
                                <line x1="4" y1="16" x2="4" y2="16.01" />
                                <line x1="20" y1="16" x2="20" y2="16.01" />
                                <line x1="4" y1="20" x2="4" y2="20.01" />
                                <line x1="8" y1="20" x2="8" y2="20.01" />
                                <line x1="12" y1="20" x2="12" y2="20.01" />
                                <line x1="16" y1="20" x2="16" y2="20.01" />
                                <line x1="20" y1="20" x2="20" y2="20.01" />
                                </svg>
                        </nb-action>
                    </nb-actions>
                </div>    
            </div>
            <div class="select-row">
                <div class="element-selector">
                    <nb-actions size="tiny">
                        <nb-action class="title">Padding:</nb-action>
                    </nb-actions>
                </div>
                <div class="element-values">
                    <nb-actions size="tiny">
                        <nb-action title="All"
                        class="popover-icon"
                        [nbPopover]="paddingPop" 
                        [nbPopoverContext]="{title:'Padding',color:textColor,colors:fillColors,content:selectedContent,target:'parent',property:'padding',status:status}" nbPopoverPlacement="top">
                            <svg viewBox="0 0 24 24" id="ic_border_outer_24px" width="100%" height="100%" fill="var(--actions-icon-color)">
                                <path d="M13 7h-2v2h2V7zm0 4h-2v2h2v-2zm4 0h-2v2h2v-2zM3 3v18h18V3H3zm16 16H5V5h14v14zm-6-4h-2v2h2v-2zm-4-4H7v2h2v-2z" />
                            </svg>
                        </nb-action>
                        <nb-action title="Top" 
                            class="popover-icon"
                            [nbPopover]="paddingPop"
                            nbPopoverPlacement="top"
                            [nbPopoverContext]="{title:'Padding',color:textColor,colors:fillColors,content:selectedContent,target:'parent',property:'paddingTop'}">
                            <svg viewBox="0 0 24 24" id="ic_border_top_24px" width="100%" height="100%" fill="var(--actions-icon-color)">
                                <path d="M7 21h2v-2H7v2zm0-8h2v-2H7v2zm4 0h2v-2h-2v2zm0 8h2v-2h-2v2zm-8-4h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2v-2H3v2zm0-4h2V7H3v2zm8 8h2v-2h-2v2zm8-8h2V7h-2v2zm0 4h2v-2h-2v2zM3 3v2h18V3H3zm16 14h2v-2h-2v2zm-4 4h2v-2h-2v2zM11 9h2V7h-2v2zm8 12h2v-2h-2v2zm-4-8h2v-2h-2v2z"/>
                            </svg>
                        </nb-action>
                        <nb-action title="Right" 
                        class="popover-icon"
                            [nbPopover]="paddingPop"
                            nbPopoverPlacement="top"
                            [nbPopoverContext]="{title:'Padding',color:textColor,colors:fillColors,content:selectedContent,target:'parent',property:'paddingRight'}">
                            <svg viewBox="0 0 24 24" id="ic_border_right_24px" width="100%" height="100%" fill="var(--actions-icon-color)">
                                <path d="M7 21h2v-2H7v2zM3 5h2V3H3v2zm4 0h2V3H7v2zm0 8h2v-2H7v2zm-4 8h2v-2H3v2zm8 0h2v-2h-2v2zm-8-8h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm8 8h2v-2h-2v2zm4-4h2v-2h-2v2zm4-10v18h2V3h-2zm-4 18h2v-2h-2v2zm0-16h2V3h-2v2zm-4 8h2v-2h-2v2zm0-8h2V3h-2v2zm0 4h2V7h-2v2z"/>
                            </svg>
                        </nb-action>
                        <nb-action title="Bottom" 
                            class="popover-icon"
                            [nbPopover]="paddingPop"
                            nbPopoverPlacement="top"
                            [nbPopoverContext]="{title:'Padding',color:textColor,colors:fillColors,content:selectedContent,target:'parent',property:'paddingBottom'}">
                            <svg viewBox="0 0 24 24" id="ic_border_bottom_24px" width="100%" height="100%" fill="var(--actions-icon-color)">
                                <path d="M9 11H7v2h2v-2zm4 4h-2v2h2v-2zM9 3H7v2h2V3zm4 8h-2v2h2v-2zM5 3H3v2h2V3zm8 4h-2v2h2V7zm4 4h-2v2h2v-2zm-4-8h-2v2h2V3zm4 0h-2v2h2V3zm2 10h2v-2h-2v2zm0 4h2v-2h-2v2zM5 7H3v2h2V7zm14-4v2h2V3h-2zm0 6h2V7h-2v2zM5 11H3v2h2v-2zM3 21h18v-2H3v2zm2-6H3v2h2v-2z"/>
                            </svg>
                        </nb-action>
                        <nb-action title="Left" 
                            class="popover-icon"
                            [nbPopover]="paddingPop"
                            nbPopoverPlacement="top"
                            [nbPopoverContext]="{title:'Padding',color:textColor,colors:fillColors,content:selectedContent,target:'parent',property:'paddingLeft'}">
                            <svg viewBox="0 0 24 24" id="ic_border_left_24px" width="100%" height="100%" fill="var(--actions-icon-color)">
                                <path d="M11 21h2v-2h-2v2zm0-4h2v-2h-2v2zm0-12h2V3h-2v2zm0 4h2V7h-2v2zm0 4h2v-2h-2v2zm-4 8h2v-2H7v2zM7 5h2V3H7v2zm0 8h2v-2H7v2zm-4 8h2V3H3v18zM19 9h2V7h-2v2zm-4 12h2v-2h-2v2zm4-4h2v-2h-2v2zm0-14v2h2V3h-2zm0 10h2v-2h-2v2zm0 8h2v-2h-2v2zm-4-8h2v-2h-2v2zm0-8h2V3h-2v2z"/>
                            </svg>
                        </nb-action>
                    </nb-actions>
                </div>    
            </div>
            <div class="select-row">
                <div class="element-selector">
                    <nb-actions size="tiny">
                        <nb-action class="title">Width:</nb-action>
                    </nb-actions>
                </div>
                <div class="element-values">
                    <nb-actions size="tiny">
                        <nb-action>
                            <div class="radio-group-wrapper">
                                <nb-radio-group [value]="selectedWidth" (valueChange)="onWidthChange($event)">
                                    <nb-radio *ngFor="let option of widthOptions" [value]="option">{{option.name}}</nb-radio>
                                </nb-radio-group>
                            </div>
                        </nb-action>
                    </nb-actions>
                </div>
            </div>
            <!-- <div class="select-row">
                    <div class="element-values">
                        <div class="element-selector">
                            <div class="element-label">
                                <div class="title">Layout Declarations:</div>
                            </div>
                            <div class="element-label selector">
                                <nb-select [(selected)]="selectedDelcaration" [placeholder]="selectedDelcaration"  (selectedChange)="changeDeclaration($event)" size="tiny" fullWidth>
                                    <nb-option *ngFor="let declaration of layoutDeclarations" [value]="declaration">{{ declaration.name }}</nb-option>
                                </nb-select>
                            </div>
                            <ng-container [ngSwitch]="selectedDelcaration?.declaration">
                                <ng-container *ngSwitchCase="'padding'">
                                    
                                </ng-container>
                                <ng-container *ngSwitchCase="'margin'">
                                    
                                </ng-container>
                                <ng-container *ngSwitchCase="'border'">
                                    
                                </ng-container>
                                <ng-container *ngSwitchCase="'width'">
                                    
                                </ng-container>
                            </ng-container> 
                        </div>
                            
                    </div>   
            </div> -->
            <!-- <div class="select-row">
    
                    <div class="element-values">
                        <div class="element-selector">
                            <div class="element-label">
                                <div class="title">Container Styles:</div>
                            </div>
                            <div class="element-label selector">
                                <nb-select [(selected)]="selectedDelcaration" [placeholder]="selectedDelcaration"  (selectedChange)="changeDeclaration($event)" size="tiny" fullWidth>
                                    <nb-option *ngFor="let declaration of layoutDeclarations" [value]="declaration">{{ declaration.name }}</nb-option>
                                </nb-select>
                            </div>
                            <nb-actions size="tiny">
                                <nb-action>Width</nb-action>
                                <nb-action>
                                    <div class="radio-group-wrapper">
                                        <nb-radio-group [value]="selectedWidth" (valueChange)="onWidthChange($event)">
                                            <nb-radio *ngFor="let option of widthOptions" [value]="option">{{option.name}}</nb-radio>
                                        </nb-radio-group>
                                    </div>
                                </nb-action>
                                <nb-action title="Fill Color"
                                    class="popover-icon"
                                    [nbPopover]="component" 
                                    [nbPopoverContext]="{color:textColor,colors:fillColors,content:selectedContent,target:'container',property:'background'}" nbPopoverPlacement="top">
                                    <svg viewBox="0 0 24 24" id="ic_format_color_fill_24px" width="100%" height="100%" fill="var(--actions-icon-color)">
                                        <path d="M16.56 8.94L7.62 0 6.21 1.41l2.38 2.38-5.15 5.15a1.49 1.49 0 0 0 0 2.12l5.5 5.5c.29.29.68.44 1.06.44s.77-.15 1.06-.44l5.5-5.5c.59-.58.59-1.53 0-2.12zM5.21 10L10 5.21 14.79 10H5.21zM19 11.5s-2 2.17-2 3.5c0 1.1.9 2 2 2s2-.9 2-2c0-1.33-2-3.5-2-3.5z"/>
                                        <path fill-opacity=".36" d="M0 20h24v4H0z" />
                                    </svg>
                                </nb-action>
                                <nb-action title="All"
                            class="popover-icon"
                            [nbPopover]="borderPop" 
                                [nbPopoverContext]="{title:'Border',color:textColor,colors:fillColors,content:selectedContent,target:'parent',property:'background'}" nbPopoverPlacement="top">
                                <svg viewBox="0 0 24 24" id="ic_border_outer_24px" width="100%" height="100%" fill="var(--actions-icon-color)">
                                    <path d="M13 7h-2v2h2V7zm0 4h-2v2h2v-2zm4 0h-2v2h2v-2zM3 3v18h18V3H3zm16 16H5V5h14v14zm-6-4h-2v2h2v-2zm-4-4H7v2h2v-2z" />
                                </svg>
                            </nb-action>
                            <nb-action title="Top" 
                                class="popover-icon"
                                [nbPopover]="paddingPop"
                                nbPopoverPlacement="top"
                                [nbPopoverContext]="{title:'Border',color:textColor,colors:fillColors,content:selectedContent,target:'parent',property:'borderTop'}">
                                <svg viewBox="0 0 24 24" id="ic_border_top_24px" width="100%" height="100%" fill="var(--actions-icon-color)">
                                    <path d="M7 21h2v-2H7v2zm0-8h2v-2H7v2zm4 0h2v-2h-2v2zm0 8h2v-2h-2v2zm-8-4h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2v-2H3v2zm0-4h2V7H3v2zm8 8h2v-2h-2v2zm8-8h2V7h-2v2zm0 4h2v-2h-2v2zM3 3v2h18V3H3zm16 14h2v-2h-2v2zm-4 4h2v-2h-2v2zM11 9h2V7h-2v2zm8 12h2v-2h-2v2zm-4-8h2v-2h-2v2z"/>
                                </svg>
                            </nb-action>
                            <nb-action title="Right" 
                            class="popover-icon"
                                [nbPopover]="paddingPop"
                                nbPopoverPlacement="top"
                                [nbPopoverContext]="{title:'Border',color:textColor,colors:fillColors,content:selectedContent,target:'parent',property:'borderRight'}">
                                <svg viewBox="0 0 24 24" id="ic_border_right_24px" width="100%" height="100%" fill="var(--actions-icon-color)">
                                    <path d="M7 21h2v-2H7v2zM3 5h2V3H3v2zm4 0h2V3H7v2zm0 8h2v-2H7v2zm-4 8h2v-2H3v2zm8 0h2v-2h-2v2zm-8-8h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm8 8h2v-2h-2v2zm4-4h2v-2h-2v2zm4-10v18h2V3h-2zm-4 18h2v-2h-2v2zm0-16h2V3h-2v2zm-4 8h2v-2h-2v2zm0-8h2V3h-2v2zm0 4h2V7h-2v2z"/>
                                </svg>
                            </nb-action>
                            <nb-action title="Bottom" 
                                class="popover-icon"
                                [nbPopover]="paddingPop"
                                nbPopoverPlacement="top"
                                [nbPopoverContext]="{title:'Border',color:textColor,colors:fillColors,content:selectedContent,target:'parent',property:'borderBottom'}">
                                <svg viewBox="0 0 24 24" id="ic_border_bottom_24px" width="100%" height="100%" fill="var(--actions-icon-color)">
                                    <path d="M9 11H7v2h2v-2zm4 4h-2v2h2v-2zM9 3H7v2h2V3zm4 8h-2v2h2v-2zM5 3H3v2h2V3zm8 4h-2v2h2V7zm4 4h-2v2h2v-2zm-4-8h-2v2h2V3zm4 0h-2v2h2V3zm2 10h2v-2h-2v2zm0 4h2v-2h-2v2zM5 7H3v2h2V7zm14-4v2h2V3h-2zm0 6h2V7h-2v2zM5 11H3v2h2v-2zM3 21h18v-2H3v2zm2-6H3v2h2v-2z"/>
                                </svg>
                            </nb-action>
                            <nb-action title="Left" 
                                class="popover-icon"
                                [nbPopover]="paddingPop"
                                nbPopoverPlacement="top"
                                [nbPopoverContext]="{title:'Border',color:textColor,colors:fillColors,content:selectedContent,target:'parent',property:'borderLeft'}">
                                <svg viewBox="0 0 24 24" id="ic_border_left_24px" width="100%" height="100%" fill="var(--actions-icon-color)">
                                    <path d="M11 21h2v-2h-2v2zm0-4h2v-2h-2v2zm0-12h2V3h-2v2zm0 4h2V7h-2v2zm0 4h2v-2h-2v2zm-4 8h2v-2H7v2zM7 5h2V3H7v2zm0 8h2v-2H7v2zm-4 8h2V3H3v18zM19 9h2V7h-2v2zm-4 12h2v-2h-2v2zm4-4h2v-2h-2v2zm0-14v2h2V3h-2zm0 10h2v-2h-2v2zm0 8h2v-2h-2v2zm-4-8h2v-2h-2v2zm0-8h2V3h-2v2z"/>
                                </svg>
                            </nb-action>
                            <nb-action title="Border Color"
                                class="popover-icon"
                                [nbPopover]="component" 
                                [nbPopoverContext]="{color:textColor,colors:fillColors,content:selectedContent}" nbPopoverPlacement="top">
                                <svg viewBox="0 0 24 24" id="ic_border_color_24px" width="100%" height="100%" fill="var(--actions-icon-color)">
                                    <path d="M17.75 7L14 3.25l-10 10V17h3.75l10-10zm2.96-2.96a.996.996 0 0 0 0-1.41L18.37.29a.996.996 0 0 0-1.41 0L15 2.25 18.75 6l1.96-1.96z" />
                                    <path fill-opacity=".36" d="M0 20h24v4H0z" />
                                </svg>
                            </nb-action>
                            <nb-action title="Border Radius Presets"
                                class="popover-icon"
                                [nbPopover]="component" 
                                [nbPopoverContext]="{color:textColor,colors:fillColors,content:selectedContent}" nbPopoverPlacement="top">
                                <svg fill="none" width="100%" height="100%" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                    <path d="m3 5.75c0-1.51878 1.23122-2.75 2.75-2.75h12.5c1.5188 0 2.75 1.23122 2.75 2.75v12.5c0 1.5188-1.2312 2.75-2.75 2.75h-12.5c-1.51878 0-2.75-1.2312-2.75-2.75zm2.75-1.25c-.69036 0-1.25.55964-1.25 1.25v12.5c0 .6904.55964 1.25 1.25 1.25h12.5c.6904 0 1.25-.5596 1.25-1.25v-12.5c0-.69036-.5596-1.25-1.25-1.25z" fill="#212121"/>
                                </svg>
                            </nb-action>
                            <nb-action title="Border Radius"
                                class="popover-icon"
                                [nbPopover]="component" 
                                [nbPopoverContext]="{color:textColor,colors:fillColors,content:selectedContent}" nbPopoverPlacement="top">
                                <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-border-radius" width="100%" height="100%" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                    <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                                    <path d="M4 12v-4a4 4 0 0 1 4 -4h4" />
                                    <line x1="16" y1="4" x2="16" y2="4.01" />
                                    <line x1="20" y1="4" x2="20" y2="4.01" />
                                    <line x1="20" y1="8" x2="20" y2="8.01" />
                                    <line x1="20" y1="12" x2="20" y2="12.01" />
                                    <line x1="4" y1="16" x2="4" y2="16.01" />
                                    <line x1="20" y1="16" x2="20" y2="16.01" />
                                    <line x1="4" y1="20" x2="4" y2="20.01" />
                                    <line x1="8" y1="20" x2="8" y2="20.01" />
                                    <line x1="12" y1="20" x2="12" y2="20.01" />
                                    <line x1="16" y1="20" x2="16" y2="20.01" />
                                    <line x1="20" y1="20" x2="20" y2="20.01" />
                                    </svg>
                            </nb-action>    
                            </nb-actions>
                        </div>
                        
                    </div>
    
                    
            </div> -->
        </div>
            
    </div>
</ng-container>

<!--     <div class="preview-actions">
        <div class="action-button"><button nbButton size="tiny" status="primary" (click)="onUseTheme()">Use This Theme<nb-icon icon="checkmark-outline" pack="eva" status="success"></nb-icon></button></div>
    </div> -->




               






 




